import { Anchor, Card, Stack, Title } from '@mantine/core';
import { OffsiteLink } from 'components/OffsiteLink';
import { useAddress } from 'hooks/useAddress';
import { useIsMounted } from 'hooks/useIsMounted';
import { useMoonChain } from 'hooks/useMoonChainConfig';
import { useMoonChainKeyParam } from 'hooks/useMoonChainParam';
import { useTranslation } from 'next-i18next';
import Link from 'next/link';
import { Fragment } from 'react';

export function UsefulResources() {
  const { t } = useTranslation(['crowdloan-rewards', 'common']);
  const { explorerUrls } = useMoonChain();
  const moonChainKey = useMoonChainKeyParam();
  const address = useAddress();
  const isMounted = useIsMounted();

  const links = [
    {
      link: `${explorerUrls[0]}/address/${address}?toaddress=0x0000000000000000000000000000000000000801`,
      label: t('claimHistory'),
    },
    {
      link: 'https://moonbeam.foundation/tutorials/claim-moonbeam-crowdloan-rewards/',
      label: t('howToClaim'),
    },
    {
      link: 'https://moonbeam.foundation/news/moonbeam-crowdloan-rewards-distribution/',
      label: t('rewardsInitialDistribution'),
    },
    {
      path: 'staking',
      label: t('callToStake'),
    },
  ];

  if (!isMounted) return null;

  return (
    <Card withBorder p={'xl'}>
      <Title order={2} size={'h4'} mb={'lg'}>
        {t('usefulResources', { ns: 'common' })}
      </Title>
      <Stack h={293} gap={'lg'} align={'flex-start'}>
        {links.map((link, index) => (
          <Fragment key={index}>
            {link.link ? (
              <OffsiteLink
                key={index}
                link={link.link}
                label={t(link.label)}
                size={'md'}
              />
            ) : (
              <Anchor
                component={Link}
                href={{
                  pathname: link.path ?? '',
                  query: { moonChainKey },
                }}
                passHref
              >
                {t(link.label)}
              </Anchor>
            )}
          </Fragment>
        ))}
      </Stack>
    </Card>
  );
}
